import styled from '@emotion/styled'

export const Overview = styled.div({
  marginLeft: '0.5em',
  display: 'flex',
  flexDirection: 'row',
})

export const Statistics = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
})

export const StatisticsRow = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const Table = styled.div({
  overflow: 'scroll',
  marginTop: '5px',
  marginLeft: '5px',
})
export const Row = styled.div<{ backgroundShade: string }>(
  {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
  },
  ({ backgroundShade }) => ({
    background:
      backgroundShade == 'dark'
        ? '#f8f8f8'
        : backgroundShade == 'error'
          ? '#fee'
          : backgroundShade == 'inside'
            ? '#c7f2d0'
            : '#ffffff',
  })
)
export const CellIndex = styled.div({
  minWidth: '2em',
})
export const CellLatLon = styled.div({
  minWidth: '11em',
})
export const CellAccuracy = styled.div({
  minWidth: '5em',
})
export const CellDelta = styled.div({
  textAlign: 'center',
  minWidth: '4em',
})
export const CellMocked = styled.div({
  minWidth: '5em',
})
export const CellPreciseAccuracy = styled.div({
  minWidth: '5em',
})
export const CellTime = styled.div({
  minWidth: '10em',
})

export const CellInside = styled.div({
  minWidth: '5em',
})
export const CellDistance = styled.div({
  minWidth: '5em',
})
export const CellVenueLocation = styled.div({
  minWidth: '10em',
})

export const CellVenueName = styled.div({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '20em',
  minWidth: '20em',
  width: '20em',
})
export const CellError = styled.div({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: '10em',
})
export const DiagnosticsCoordinates = styled.div({
  // marginLeft: '10px',
  // fontSize: '1.2em',
})
export const LocalButton = styled.button({
  padding: '2px 5px',
  fontSize: '1.2em',
  borderRadius: '4px',
  float: 'right',
  background: '#8246af',
  color: '#fff',
  marginRight: '5px',
})
